<svelte:options
  customElement={{
    tag: "oc-promo-card-v1",
    /*                                            */
    extend: window.__components.extend({ slots: ["default", "logo", "tags"] }),
    props: {
      aspectRatio: { type: "String", attribute: "aspect-ratio", reflect: true },
      firstHeadline: { type: "String", attribute: "first-headline", reflect: true },
      overline: { type: "String", reflect: true },
      secondHeadline: { type: "String", attribute: "second-headline", reflect: true },
      text: { type: "String", reflect: true },
    },
  }}
/>

<script lang="ts">
  import { usePropertyChange } from "../../../common/utils/usePropertyChange";
  import type { Props } from "./PromoCardV1.types.js";

  usePropertyChange();

  export let slots: HasSlots<typeof $$slots>;
  export let aspectRatio: Props["aspectRatio"];
  export let firstHeadline: Props["firstHeadline"] = undefined;
  export let overline: Props["overline"] = undefined;
  export let secondHeadline: Props["secondHeadline"] = undefined;
  export let text: Props["text"] = undefined;

  export let host: HTMLInputElement;

  host.tabIndex = 0;
</script>

<article class="promo-card">
  {#if overline || firstHeadline || $slots.logo}
    <header class="promo-card__header">
      <div class="promo-card__header-container">
        {#if overline}
          <span class="promo-card__header-container-overline">{overline}</span>
        {/if}
        {#if firstHeadline}
          <span class="promo-card__header-container-first-headline">{firstHeadline}</span>
        {/if}
      </div>
      {#if $slots.logo}
        <div class="promo-card__header-logo">
          <slot name="logo" />
        </div>
      {/if}
    </header>
  {/if}

  <div class="promo-card__body">
    <slot />
    {#if $slots.tags}
      <div class="promo-card__tag-container">
        <slot name="tags" />
      </div>
    {/if}
  </div>

  {#if secondHeadline || text}
    <footer class="promo-card__footer">
      {#if secondHeadline}
        <span class="promo-card__footer-second-headline">{secondHeadline}</span>
      {/if}
      {#if text}
        <span class="promo-card__footer-text">{text}</span>
      {/if}
    </footer>
  {/if}
</article>

<style lang="scss">
  @use "../../../../../../node_modules/@otto-ec/design-tokens/tokens";
  @use "../../../common/scss/mixins/mixins";

  .promo-card__header {
    display: flex;
    flex-direction: row;
    gap: tokens.$oc-component-promo-card-gap-logo;
    padding: tokens.$oc-component-promo-card-padding-x tokens.$oc-component-promo-card-padding-y;

    height: calc(80px - 2 * tokens.$oc-component-promo-card-padding-y);
    @include mixins.breakpoint-from-l {
      height: calc(88px - 2 * tokens.$oc-component-promo-card-padding-y);
    }

    &-container {
      display: flex;
      flex-direction: column;
      justify-content: center;

      /*                           */
      flex: 1;
      &,
      & > * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &-overline {
        font: tokens.$oc-component-promo-card-overline-font;
      }

      &-first-headline {
        font: tokens.$oc-component-promo-card-s-m-first-headline-font;
        @include mixins.breakpoint-from-l {
          font: tokens.$oc-component-promo-card-l-xl-first-headline-font;
        }
      }
    }
  }

  /*               */
  .promo-card__body {
    position: relative;
  }
  .promo-card__tag-container {
    bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px;
    position: absolute;
  }

  .promo-card__footer {
    display: flex;
    flex-direction: column;
    min-height: 24px;
    padding: 16px;

    &-second-headline {
      /*                         */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      overflow: hidden;

      font: tokens.$oc-component-promo-card-s-m-second-headline-font;
      @include mixins.breakpoint-from-l {
        font: tokens.$oc-component-promo-card-l-xl-second-headline-font;
      }
    }

    &-text {
      font: tokens.$oc-component-promo-card-text-font;
    }
  }
</style>
